import "./Center_module.css";
const Center_module = {
    center: "center__f299f7883d1ad008",
    centerText: "centerText__f299f7883d1ad008",
    centerChildren: "centerChildren__f299f7883d1ad008"
};
export { Center_module as default };
